import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllUsers as apiDeleteAllUsers } from "../../api/apiUsers";
import { toast } from "react-hot-toast";
import getErrorMessageFromAxiosError from "../../utils/parseError";


export function useDeleteAllUsers() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllUsers,
        isPending: isDelete,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiDeleteAllUsers(req),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({
                queryKey: ["users"],
            });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something Wont Wrong!");
            toast.error(msg);
        },

    });

    return { deleteAllUsers, isDelete, error, results };
}
